import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getCentralisationInsurerLabel } from 'src/app/_enums/centralisation-insurer.enum';
import { getInsuranceTypeLabel } from 'src/app/_enums/insurance-type.enum';
import { ProposalService } from 'src/app/_services/proposal.service';
import { UserAuthService } from 'src/app/_services/user-auth.service';
import { CentralisationTrackingInfo } from 'src/app/_types/centralisation.types';
import { CentralisationMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class CentralisationMetadataComponentAbstract
  extends BaseMetadataComponent<CentralisationMetadata>
  implements OnInit
{
  @Input()
  leadId!: string;

  getCentralisationInsurerLabel = getCentralisationInsurerLabel;

  getInsuranceTypeLabel = getInsuranceTypeLabel;

  insurerTrackingInfo!: CentralisationTrackingInfo[];

  submitted = false;

  @Output()
  done = new EventEmitter();

  constructor(
    userAuthService: UserAuthService,
    private readonly proposalService: ProposalService,
    private readonly toastrService: ToastrService
  ) {
    super(userAuthService);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.insurerTrackingInfo = this.metadata.trackingInfo;
  }

  getInsurerLabel(item: CentralisationTrackingInfo): string {
    if (item.companyId) {
      return item.companyName ?? item.companyId;
    }
    return getCentralisationInsurerLabel(item.insurer ?? '');
  }

  getTrackingKey(item: CentralisationTrackingInfo): string {
    return item.companyId ?? item.insurer ?? '';
  }

  hasSameTrackingElement(
    candidate: CentralisationTrackingInfo,
    list: CentralisationTrackingInfo[] = []
  ): boolean {
    return list.some(
      (element) =>
        this.getTrackingKey(element) === this.getTrackingKey(candidate) &&
        JSON.stringify(
          (element.insurances ?? [])
            .map((insurance) => insurance.insurance)
            .sort((a, b) => a.localeCompare(b))
        ) ===
          JSON.stringify(
            (candidate.insurances ?? [])
              .map((insurance) => insurance.insurance)
              .sort((a, b) => a.localeCompare(b))
          )
    );
  }

  updateCentralisationTrackingInfo() {
    if (this.submitted) return;
    this.submitted = true;
    this.proposalService
      .updateCentralisationTrackingStatus({
        leadId: this.leadId,
        insurerInfo: this.insurerTrackingInfo,
      })
      .subscribe({
        next: () => {
          this.toastrService.success(
            $localize`Demande mise à jour avec succès`
          );
          this.done.emit();
          this.submitted = false;
        },
        error: () => {
          this.toastrService.error(
            $localize`Une erreur est survenue. Veuillez réessayer`
          );
          this.submitted = false;
        },
      });
  }

  completeCentralisation() {
    this.insurerTrackingInfo.forEach((insurer) =>
      insurer.insurances.forEach((insurance) => (insurance.done = true))
    );
    this.updateCentralisationTrackingInfo();
  }
}
